<template>
    <div class="icoButton" data-icoTarget="sync" :class="classRefreshing" v-on:click="clickIco" v-on="$listeners"></div>
</template>

<script>
    export default {
        name: 'RefreshIco',
        data() {
            return {
                showToast: false,
                classRefreshing: '',
                dateRefreshing: null,
                controlRefreshing: null,
                countRefreshing: 0,
            };
        },
        mounted() {
            this.$onInstance('startRefresh', this.startRefresh);
            this.$onInstance('endRefresh', this.endRefresh);
        },
        methods: {
            clickIco() {
                this.$emitInstance('refresh');
                this.showToast = true;
            },
            startRefresh() {
                this.countRefreshing++;
            },
            endRefresh() {
                this.countRefreshing--;
            },
        },
        watch: {
            countRefreshing: {
                immediate: false,
                handler(val) {
                    //Evitar que se ejecute si se quita el loading y se activa de nuevo en el momento
                    if (this.controlRefreshing) clearTimeout(this.controlRefreshing);
                    if (val > 0) {
                        this.classRefreshing = 'sync';
                        if (this.dateRefreshing == null) this.dateRefreshing = new Date().getMilliseconds();
                    } else
                        this.controlRefreshing = setTimeout(() => {
                            if (val == 0) {
                                this.classRefreshing = '';
                                this.dateRefreshing = null;
                                if (this.showToast) {
                                    this.showToast = false;
                                    this.$toast({
                                        message: this.$dicc.common.updated,
                                        container: '#body',
                                        type: 'is-success',
                                    });
                                }
                            }
                        }, 1000 + this.dateRefreshing - new Date().getMilliseconds());
                },
            },
        },
    };
</script>
